import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
//api
import { getLibrariesApi } from 'api/library';
//components
import AutoCompleteInput from './autoCompleteInput';

const SearchLibraryInput = ({ value, onSelected, defaultLibrary = null }) => {
  const { t } = useTranslation(['backoffice']);
  const [librarySelected, setLibrarySelected] = useState(null);

  useEffect(() => {
    if (defaultLibrary) {
      setLibrarySelected({
        label: defaultLibrary.denominacion,
        value: defaultLibrary.id,
      });
    } else setLibrarySelected(null)
  }, [defaultLibrary]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      const { status, data } = await getLibrariesApi({ denominacion: value, page: 1, page_size: 10 });
      if (status === 200) {
        return data?.results?.map((item) => ({
          ...item,
          label: item.denominacion,
          value: item.id,
        }));
      }
    }
    return [];
  };

  return (
    <AutoCompleteInput
      defaultOptions={librarySelected ? [librarySelected] : []}
      defaultValue={librarySelected}
      label={t('library')}
      placeholder={t('searchByName')}
      onSearch={onSearch}
      onSelect={onSelected}
    />
  );
};

SearchLibraryInput.propTypes = {
  onSelected: PropTypes.func,
  value: PropTypes.any,
  defaultLibrary: PropTypes.object,
};

export default SearchLibraryInput;
